import React from 'react';
import { LocalPopup, ManagedPopup } from 'js/components/common/Popup';
import { WebContent } from 'js/components/system/WebContent';
import { useCombinedOnClose } from 'js/components/common/PopupManager';
import { useCombinedHandler } from 'js/hooks/useCombinedHandler';
import { useSmartTranslations } from 'js/hooks/i18n';
import style from 'js/components/common/popups/ConfirmationPopup/index.scss';

const classNames = { inner: style.inner };

export const getAcceptDeclineButtons = ({
    onAcceptClick,
    onDeclineClick,
    acceptBtnText = 'playtech.mobile.system.message.accept',
    declineBtnText = 'playtech.mobile.system.message.decline'
}) => [
    { onClick: onDeclineClick, text: declineBtnText, className: style.btn, view: 'secondary', color: 'info' },
    { onClick: onAcceptClick, text: acceptBtnText, className: style.btn }
];

export const makeConfirmationPopup = WrapperPopup => ({
    title,
    onClose,
    onAccept,
    controls,
    onDecline,
    articleId,
    content = '',
    acceptBtnText,
    declineBtnText,
    ...other
}) => {
    const t = useSmartTranslations();
    const closePopup = useCombinedOnClose(onClose);
    const onAcceptClick = useCombinedHandler([onAccept, closePopup]);
    const onDeclineClick = useCombinedHandler([onDecline, closePopup]);

    const buttons = getAcceptDeclineButtons({ acceptBtnText, declineBtnText, onAcceptClick, onDeclineClick });

    return (
        <WrapperPopup
            title={title}
            buttons={buttons}
            controls={controls}
            onClose={closePopup}
            classNames={classNames}
            className={style.popup}
            {...other}
        >
            <WebContent content={t(content)} id={articleId} className={style.content} />
        </WrapperPopup>
    );
};

export const ManagedConfirmationPopup = makeConfirmationPopup(ManagedPopup);

export const LocalConfirmationPopup = makeConfirmationPopup(LocalPopup);
